import ObjectEditor from '../object-editor'

import renderForm from './base.pug'

export default class Base extends ObjectEditor
  renderForm: renderForm
